import React from "react";

function Privacy() {
  return (
    <div className="p-6 md:p-10 text-gray-800 font-sans max-w-5xl mx-auto">
      <h1 className="text-2xl md:text-3xl font-bold mb-4">
        Wedding Stays Privacy Policy
      </h1>

      <p className="text-lg mb-4">
        At Wedding Stays, we value your trust and are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, and safeguard your data when you visit our website or use our
        services.
      </p>

      {/* Who We Are */}
      <h2 className="text-xl font-semibold mt-6 mb-2">Who Are We?</h2>

      <p className="text-lg">
        Wedding Stays is a hospitality-focused wedding accommodation management
        platform that assists families in organizing guest stays for destination
        and multi-day weddings across India. We operate in compliance with the
        Digital Personal Data Protection Act, 2023 and applicable Indian laws.
        When we collect and process your personal data, we act as the “Data
        Fiduciary” responsible for protecting that information.
      </p>

      {/* Data Collection */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        How Do We Collect Your Data?
      </h2>

      <p className="text-lg">
        We collect personal information directly from you through:
      </p>

      <ul className="list-disc pl-6 text-lg mt-2 space-y-1">
        <li>Consultation and availability inquiry forms</li>
        <li>Guest accommodation planning requests</li>
        <li>Website contact forms</li>
        <li>Email and phone communications</li>
        <li>Cookies and analytics tools</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4">
        Examples of Personal Information We May Collect:
      </h3>

      <ul className="list-disc pl-6 text-lg space-y-1">
        <li>Name of the host or guest</li>
        <li>Phone number and email address</li>
        <li>Wedding dates and event details</li>
        <li>Number of guests and accommodation preferences</li>
        <li>City or venue location</li>
        <li>Payment-related information (where applicable)</li>
        <li>Device and browser information via cookies</li>
      </ul>

      {/* Usage */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        How We Use Your Information
      </h2>

      <p className="text-lg">
        We use your information only for legitimate business purposes such as:
      </p>

      <ul className="list-disc pl-6 text-lg mt-2 space-y-1">
        <li>Planning and managing wedding guest accommodation</li>
        <li>Coordinating with partner hotels and vendors</li>
        <li>Responding to inquiries and consultation requests</li>
        <li>Improving our services and customer experience</li>
        <li>Complying with legal and regulatory requirements</li>
      </ul>

      {/* Sharing */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        Do We Share Your Information?
      </h2>

      <p className="text-lg">
        We do not sell or rent your personal data. However, we may share limited
        information with:
      </p>

      <ul className="list-disc pl-6 text-lg mt-2 space-y-1">
        <li>Partner hotels for room allocation and coordination</li>
        <li>Transport vendors for guest logistics</li>
        <li>Technology service providers supporting our website</li>
        <li>Legal authorities when required by law</li>
      </ul>

      {/* Data Security */}
      <h2 className="text-xl font-semibold mt-6 mb-2">Data Security</h2>

      <p className="text-lg">
        We implement appropriate technical and organizational measures to
        safeguard your personal data against unauthorized access, misuse, or
        disclosure.
      </p>

      {/* Your Rights */}
      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>

      <p className="text-lg">
        You have the right to request access, correction, or deletion of your
        personal data. If you wish to exercise these rights, you may contact us
        using the details provided below.
      </p>

      {/* Contact */}
      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>

      <p className="text-lg">
        If you have any questions or concerns regarding this Privacy Policy,
        please contact Wedding Stays through our official website contact form.
      </p>

      <p className="text-lg mt-6 font-medium">
        By using our website and services, you agree to the terms outlined in
        this Privacy Policy.
      </p>
    </div>
  );
}

export default Privacy;
